import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Numbers } from '../../../core/utility';
import { SubscriptionInvoiceType } from 'custom-type';
const numberFormat: Numbers = new Numbers();

const CURRENCY_SYMBOLS: Record<string, string> = {
  INR: '₹', USD: '$', CAD: 'CA$', EUR: '€', GBP: '£', AED: 'د.إ', KES: 'KSh', NPR: 'रू',
};

interface TaxInformationProps {
  invoice: SubscriptionInvoiceType;
}

const TaxInformation: React.FC<TaxInformationProps> = ({invoice}) => {
  const invCurrency = String(invoice.currency || 'INR').toUpperCase();
  const isInr = invCurrency === 'INR';
  const invSym = CURRENCY_SYMBOLS[invCurrency] || '₹';
  const totalTax = Number(invoice.tax_amount ?? ((invoice.igst || 0) + (invoice.cgst || 0) + (invoice.sgst || 0)));
  // Never show an Indian GST label on a foreign invoice (even older rows stored as 'GST').
  const foreignTaxLabel = /^(gst|igst|cgst|sgst)$/i.test(String(invoice.tax_type || '').trim())
    ? 'Sales Tax'
    : (invoice.tax_type || 'Tax');
  return (
    <TableRow>
      <TableCell colSpan={6} style={{ paddingLeft: 0 }}>
        <Table style={{ width: '100%' }}>
          <TableHead>
            <TableRow className="table-bg-color">
              {/* HSN/SAC is India-specific — hidden on foreign invoices. */}
              {isInr && (
                <TableCell colSpan={3}>
                  <strong className="d-block text-center">HSN/SAC</strong>
                </TableCell>
              )}
              <TableCell>
                <strong className="d-block text-center">Taxable Value</strong>
              </TableCell>
              {!isInr ? (
                <TableCell>
                  <strong className="d-block text-center">{foreignTaxLabel}</strong>
                  <Table style={{ width: '100%', textAlign: 'center' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Amount</strong></TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableCell>
              ) : invoice.igst > 0 ? (
                <TableCell>
                  <strong className="d-block text-center">Integrated Tax</strong>
                  <Table style={{ width: '100%', textAlign: 'center' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Rate</strong></TableCell>
                        <TableCell><strong>Amount</strong></TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableCell>
              ) : (
                <>
                  <TableCell>
                    <strong className="d-block text-center">CGST</strong>
                    <Table style={{ width: '100%', textAlign: 'center' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Rate</strong></TableCell>
                          <TableCell><strong>Amount</strong></TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableCell>
                  <TableCell>
                    <strong className="d-block text-center">SGST</strong>
                    <Table style={{ width: '100%', textAlign: 'center' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>Rate</strong></TableCell>
                          <TableCell><strong>Amount</strong></TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableCell>
                </>
              )}
              <TableCell style={{ textAlign: 'right' }}>
                <strong>Total Tax Amount</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {isInr && <TableCell colSpan={3} className="text-center">{invoice.sac_code}</TableCell>}
              <TableCell style={{ textAlign: 'center' }}>{invSym}{invoice.amount}</TableCell>
              {!isInr ? (
                <TableCell style={{ textAlign: 'center' }}>
                  <Table style={{ width: '100%', textAlign: 'center' }}>
                    <TableBody>
                      <TableRow>
                        <TableCell>{invSym}{totalTax}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableCell>
              ) : invoice.igst > 0 ? (
                <TableCell style={{ textAlign: 'center' }}>
                  <Table style={{ width: '100%', textAlign: 'center' }}>
                    <TableBody>
                      <TableRow>
                        <TableCell>18%</TableCell>
                        <TableCell>{invSym}{invoice.igst}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableCell>
              ) : (
                <>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Table style={{ width: '100%', textAlign: 'center' }}>
                      <TableBody>
                        <TableRow>
                          <TableCell>9%</TableCell>
                          <TableCell>{invSym}{invoice.cgst}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Table style={{ width: '100%', textAlign: 'center' }}>
                      <TableBody>
                        <TableRow>
                          <TableCell>9%</TableCell>
                          <TableCell>{invSym}{invoice.sgst}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableCell>
                </>
              )}
              <TableCell style={{ textAlign: 'right' }}>{invSym}{isInr ? (invoice.igst > 0 ? invoice.igst : (invoice.cgst + invoice.sgst)) : totalTax}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={8} className="inv-table-footer">
                 <span className="d-block ps-3 ps-lg-0 mb-md-3 "  style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', paddingTop: '30px', textTransform:'capitalize' }}><strong>Tax Amount (in words): </strong> {isInr ? 'INR' : invCurrency} {isInr ? (invoice.igst > 0 ? numberFormat.convertToWords(invoice.igst) : numberFormat.convertToWords(invoice.cgst + invoice.sgst)) : numberFormat.convertToWords(totalTax)} only</span>
                {/* <strong>Tax Amount (in words): </strong>
                <>
                  INR {invoice.igst > 0 ? numberFormat.convertToWords(invoice.igst) : numberFormat.convertToWords(invoice.cgst + invoice.sgst)} only
                </> */}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableCell>
    </TableRow>
  );
}

export default TaxInformation;